import { createApp } from './vue';

import imageGallery from './vue/apps/image-gallery';

const imageGalleryMountingContainer = document.querySelectorAll('.js-image-gallery');

if (imageGalleryMountingContainer) {
    imageGalleryMountingContainer.forEach((el) => {
        createApp(imageGallery).mount(el);
    });
}
